import type { IconProps } from './types';

export const CommentIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.6067 12.0003C19.6067 7.79906 16.2015 4.39301 12.0003 4.39286C7.79898 4.39286 4.39286 7.79897 4.39286 12.0003C4.39292 13.5463 4.85371 14.9824 5.64482 16.1819C5.79231 16.3806 5.83882 16.6466 5.74443 16.8948L5.7454 16.8958L4.80986 19.3841L8.1956 18.7718L8.31865 19.4524L8.31083 19.4065L8.1956 18.7718L8.20243 18.7708L8.20927 18.7688C8.37832 18.74 8.54306 18.7727 8.68388 18.847C9.68544 19.333 10.8098 19.6067 12.0003 19.6067C16.2014 19.6066 19.6066 16.2014 19.6067 12.0003ZM21.1067 12.0003C21.1066 17.0299 17.0299 21.1066 12.0003 21.1067C10.657 21.1067 9.38138 20.8118 8.23173 20.2884L3.77665 21.095L3.67704 21.1067C3.44474 21.1174 3.21804 21.0187 3.06669 20.8372C2.89398 20.6299 2.84578 20.3456 2.94072 20.0931L4.20927 16.7171C3.37437 15.3409 2.89292 13.726 2.89286 12.0003C2.89286 6.97054 6.97055 2.89286 12.0003 2.89286C17.03 2.89301 21.1067 6.97064 21.1067 12.0003Z"
        fill={color}
      />
    </svg>
  );
};
